module.exports = __webpack_public_path__ + "static/media/projector.341e2cd2.svg";